export type IInitGeneratePostJson = IDCA.IGenericFunc;

export function _initGeneratePostJson(): void {
  const $forms = $('form.generate-post-json');
  $forms.on('submit', (e) => {
    e.preventDefault();
    const $form = $(e.currentTarget) as JQuery<HTMLFormElement>;
    const json = window.DexeroCoreApp.generateWebservicePostJson($form);
    const $modal = $('#generic-modal');
    const $title = $modal.find('.modal-custom-title');
    const $loadingHolder = $modal.find('.loading-holder');
    const $ajaxHolder = $modal.find('.modal-ajax-holder');
    setTimeout(() => {
      const $button = $form.find('button[type="submit"].disabled');
      if ($button.length) {
        window.DexeroCoreApp.animateButton($button);
      }
    }, 250);

    $title.text(`Post JSON pour: ${$form.attr('id')}`);
    $loadingHolder.addClass('hide');
    $ajaxHolder
      .empty()
      .html(`<pre>${window.DexeroCoreApp.syntaxHighlightJson(JSON.stringify(json, null, 2))}</pre>`)
      .removeClass('hide');
    $modal.modal('show');
  });
}
